import { DriveItem } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveItemRequest } from '@/drive/types/DriveItemRequest';

import { AddSuccessItem } from './DriveModifierStore.types';

export function getDuplicateTitle(item: DriveItem): string {
  return item.isContainer() ? `Copy of ${item.title}` : item.title;
}

export function toAddSuccessItem(
  tempId: DriveItemId,
  result: DriveItem | { error: string } | undefined,
): AddSuccessItem {
  if (!result) {
    return { tempId };
  }

  if ('error' in result) {
    return { tempId, error: result.error };
  }

  return { tempId, backendItem: result };
}

export function toPrecedingNodeIds(
  requests: DriveItemRequest[],
  temporaryItems: Nullable<DriveItem>[],
): Map<DriveItemId, DriveItemId> {
  const precedingNodeIdByTempId = new Map<DriveItemId, DriveItemId>();

  temporaryItems.forEach((item, idx) => {
    const { precedingNodeId } = requests[idx];

    if (item && precedingNodeId !== undefined) {
      precedingNodeIdByTempId.set(item.id, precedingNodeId);
    }
  });

  return precedingNodeIdByTempId;
}

export function getSavedItemByTempId<T>(
  addedItems: AddSuccessItem[],
  toSavedItem: (backendItem: DriveItem) => Nullable<T>,
): Map<DriveItemId, Nullable<T>> {
  const savedItemByTempId = new Map<DriveItemId, Nullable<T>>();

  addedItems.forEach(({ tempId, backendItem }) => {
    savedItemByTempId.set(tempId, backendItem ? toSavedItem(backendItem) : null);
  });

  return savedItemByTempId;
}
